import { Disposable, IDisposable } from '../disposable';

export function on<K extends keyof HTMLElementEventMap>(element: Node, type: K, listener: (this: Node, ev: HTMLElementEventMap[K]) => any, useCapture?: boolean): IDisposable {
  element.addEventListener(type, listener as any, useCapture);
  return new Disposable(() => element.removeEventListener(type, listener as any, useCapture));
}
